module.exports = __webpack_public_path__ + "static/img/gsb.e9498a40.svg";